import request from "../../utils/request";
import { Result } from "../../models/general";
import { getFullUrl } from "../../utils/url";

export async function UploadCompanyLogo(formData: FormData, onUploadProgress?: (progressEvent: ProgressEvent) => void) {
    const response = await request.post<Result<{ logoUrl: string }>>("PayslipBranding/UploadLogo", formData, {
        onUploadProgress
    });
    const data = response.data;
    if (data && data.payload && typeof data.payload.logoUrl === 'string') {
        data.payload.logoUrl = getFullUrl(data.payload.logoUrl) || data.payload.logoUrl;
    }
    return data;
}

export async function RemoveCompanyLogo() {
    const response = await request.post<Result<boolean>>("PayslipBranding/RemoveLogo");
    return response.data;
}
